module.exports = __webpack_public_path__ + "static/media/final SV.627f2379.jpg";